import React, {useState} from "react"

import {
  DownloadButton,
  List,
  ListItemProduct,
  Pagination,
  SearchField
} from "~/components/"

import {useTranslation} from "react-i18next"
import {withUserFeedback} from "~/helpers/"
import {useApi, useDebounce} from "~/hooks/"

export const ProductList = ({disableProductActions, admin}) => {
  const {t} = useTranslation()
  const [params, setParams] = useState({
    "search[query]": "",
    page: 0
  })

  const setPage = page => setParams({"search[query]": query, page})

  const [query, setQuery] = useState("")
  useDebounce(query, 1000, () => {
    setParams({
      "search[query]": query,
      page: 0
    })
  })

  const [timestamp, setTimestamp] = useState(+new Date())
  const reload = () => setTimestamp(+new Date())

  const paramsQueryString = new URLSearchParams(params).toString()

  const data = useApi(
    "/products",
    {
      params,
      headers: {
        Accept: "application/vnd.shelf.v2"
      }
    },
    {timestamp}
  )
  const products = data && data.items
  const totalPages = data && data.total_pages

  return (
    <div className="sh-searchable-list">
      <div className="searchbar">
        <SearchField
          onChange={setQuery}
          placeholder={t("products.list.searchPlaceholder")}
        />
        <DownloadButton
          label={t("products.list.download", {format: "(.xlsx)"})}
          endpoint={`/products.xlsx?${paramsQueryString}`}
          v2
          filename="filtered_products.xlsx"
          mimeType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          automaticRetry
          key={JSON.stringify(params) + "xlsx"}
        />
        <DownloadButton
          label={t("products.list.download", {format: "(.csv)"})}
          endpoint={`/products.csv?${paramsQueryString}`}
          v2
          filename="filtered_products.csv"
          mimeType="text/csv"
          automaticRetry
          key={JSON.stringify(params) + "csv"}
        />
      </div>

      <div className="results">
        {withUserFeedback(
          () => (
            <React.Fragment>
              <List
                items={products}
                itemRenderer={ListItemProduct}
                itemDisableActions={disableProductActions}
                update={reload}
              >
                <p>{t("products.list.noResults")}</p>
              </List>
              <Pagination
                currentPage={params.page}
                totalPages={totalPages}
                onPageChange={setPage}
              />
            </React.Fragment>
          ),
          [data]
        )}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/list/ProductList.js